/**
 * API Configuration
 * Central location for API endpoints
 */

// Using PHP built-in server on port 88
// Production URL
export const API_BASE_URL = 'https://appbackend.peoppoll.com';

// Local Development (PHP built-in server on port 81):
//export const API_BASE_URL = 'http://localhost:81';

export default {
  BASE_URL: API_BASE_URL,

  // Auth endpoints
  LOGIN: `${API_BASE_URL}/login.php`,
  REGISTER: `${API_BASE_URL}/register.php`,
  LOGOUT: `${API_BASE_URL}/logout.php`,
  RESET_PASSWORD: `${API_BASE_URL}/reset_password.php`,

  // User endpoints
  MANAGE_USERS: `${API_BASE_URL}/manage_users.php`,
  GET_USER_VOTES: `${API_BASE_URL}/get_user_votes.php`,

  // Poll endpoints
  GET_POLLS: `${API_BASE_URL}/get_polls.php`,
  GET_POLLS_SIMPLE: `${API_BASE_URL}/get_polls_simple.php`,
  GET_POLL: `${API_BASE_URL}/get_poll.php`,
  GET_POLL_SIMPLE: `${API_BASE_URL}/get_poll_simple.php`,
  ADD_POLL: `${API_BASE_URL}/add_poll.php`,
  UPDATE_POLL_ANSWERS: `${API_BASE_URL}/update_poll_answers.php`,
  VOTE: `${API_BASE_URL}/vote.php`,

  // Organization endpoints
  GET_ORGANIZATION_TYPES: `${API_BASE_URL}/get_organization_types.php`,
  MANAGE_MEMBERS: `${API_BASE_URL}/manage_members.php`,
  MANAGE_ORGANIZATIONS: `${API_BASE_URL}/manage_organizations.php`,
  REGISTER_MULTIVENDOR: `${API_BASE_URL}/register_multivendor.php`,

  // Analytics
  ANALYTICS: `${API_BASE_URL}/analytics.php`,
  MANAGE_SETTINGS: `${API_BASE_URL}/manage_settings.php`,

  // AI
  GENERATE_POLL_AI: `${API_BASE_URL}/generate_poll_ai.php`,

  // Sentiments Analytics
  GET_POLL_SENTIMENTS: `${API_BASE_URL}/get_poll_sentiments.php`,

  // Super Admin Stats
  GET_SUPER_ADMIN_STATS: `${API_BASE_URL}/get_super_admin_stats.php`
};
